import { Icon, Popup } from 'semantic-ui-react';
import React from 'react';
import EventWizard from '../../../../events/event-wizard/event-wizard';
import { withTranslation, WithTranslation } from 'react-i18next';

export interface CreateEventButtonProps extends WithTranslation {
  className?: string;
  onCreatedEvent?: (isSucess: boolean) => void;
}

class CreateEventButton extends React.Component<CreateEventButtonProps> {
  state = {
    showCreationWizard: false
  };

  handleOnButtonClick = () => {
    this.setState({
      showCreationWizard: true
    });
  };

  handleOnEventWizardClose = (isSuccess: boolean) => {
    this.setState({
      showCreationWizard: false
    });

    this.props.onCreatedEvent && this.props.onCreatedEvent(isSuccess);
  };

  render() {
    const t = this.props.t;
    return (
      <>
        <Popup
          content={t('New Event')}
          trigger={
            <button onClick={this.handleOnButtonClick} className={this.props.className}>
              <Icon.Group>
                <Icon name="calendar check" />
                <Icon size="small" circular name="plus circle" />
              </Icon.Group>
            </button>
          }
        />
        {this.state.showCreationWizard && <EventWizard onClose={this.handleOnEventWizardClose} />}
      </>
    );
  }
}

export default withTranslation()(CreateEventButton);
